export * from '@primeuix/themes/material/splitbutton';
export { default } from '@primeuix/themes/material/splitbutton';
